import { title } from "process"
import * as React from "react"
import { useState } from "react"
import { PopupButton } from "react-calendly"

export const Faq = () => {
  const [idx, setIdx] = useState<any>(0)
  const faqList = [
    {
      title: "How do I begin working with you?",
      info: "Starting your project with us is easy! Share your requirements, goals, and preferences, and we’ll craft a tailored solution just for you. From design and development to marketing and SEO, we ensure a seamless process with clear communication and expert execution. Let’s collaborate and turn your ideas into reality!",
    },
    {
      title: "Do you offer a free consultation before starting a project?",
      info: "We offer a free consultation to understand your project needs, discuss goals, and provide expert insights. This helps us create the perfect strategy tailored to your business. Let’s connect and explore the best solutions for your success!",
    },
    {
      title: "What industries do you serve?",
      info: "We provide custom IT solutions tailored to the unique needs of businesses in each industry. Whether you're a startup, SME, or large enterprise, Visual Folio delivers innovative, scalable, and secure digital experiences.",
    },
    {
      title: "Can you customize services to fit my business needs?",
      info: "Yes! At Visual Folio, we specialize in providing customized IT solutions tailored to your business needs.Whether you're a startup, SME, or large enterprise, we take a personalized approach to align our services with your goals.\nFree Consultation – We analyze your business requirements and suggest the best digital strategy.\nWe ensure transparency, efficiency, and measurable success in every project.\nLet’s discuss your business needs and create a custom solution that drives growth. Get in touch today! 🚀",
    },
    {
      title: "What information do I need to provide before starting a project?",
      info: "Before starting a project with Visual Folio, we need key details to ensure smooth execution and alignment with your goals:\n✅ Project Overview – A brief description of your idea, objectives, and expected outcomes.\n✅ Target Audience – Who your product or service is designed for.\n✅ Features & Requirements – Essential functionalities, design preferences, and any specific requests.\n✅ Budget & Timeline – Your estimated budget and expected delivery timeframe.\n✅ Brand Guidelines (if any) – Logos, color schemes, and design preferences for consistency.\n✅ Competitor & Industry Insights – Examples of similar projects or competitors for reference.\nWith this information, we can tailor a custom strategy and roadmap to bring your vision to life effectively! 🚀",
    },
  ]
  const otherFaqList = [
    {
      subTitle: "Project Scope & Planning",
      projectScope: [
        {
          title: "How do you define project requirements and scope?",
          info: "At Visual Folio, we define project requirements and scope through a structured approach to ensure clarity, efficiency, and alignment with your business goals.\n✅ Discovery & Consultation – We discuss your vision, objectives, and expectations.\n✅ Requirement Analysis – We identify key features, design needs, technical specifications, and user experience goals.\n✅ Scope Documentation – A detailed outline of project deliverables, timeline, and resources needed.\n✅ Budget & Timeline Alignment – We ensure feasibility within your budget and deadlines.\n✅ Approval & Roadmap – Once finalized, we create a structured plan for seamless execution.\nThis process ensures transparency, minimizes risks, and sets a strong foundation for project success. 🚀",
        },

        {
          title:
            "Can I make changes to the project scope after it has started?",
          info: "Yes, at Visual Folio, we understand that project needs may evolve. You can request changes to the project scope even after it has started.\n✅ Flexible Adjustments – We accommodate modifications while ensuring minimal disruption.\n✅ Impact Assessment – We evaluate how changes affect timelines, costs, and deliverables.\n✅ Transparent Communication – We keep you informed of any adjustments to ensure alignment.\n✅ Approval Process – Once agreed upon, we integrate changes seamlessly into the workflow.\nOur goal is to provide adaptability without compromising quality, efficiency, or deadlines. 🚀",
        },
        {
          title: "How do you handle project timelines and deadlines?",
          info: "At Visual Folio, we prioritize timely project delivery with a structured approach:\n✅ Clear Planning – We define milestones, set realistic deadlines, and create a detailed roadmap.\n✅ Agile Execution – Our team follows efficient workflows to ensure smooth progress.\n✅ Regular Updates – We keep you informed with progress reports and adjustments if needed.\n✅ Risk Management – We identify potential delays early and implement solutions proactively.\n✅ On-Time Delivery – We stay committed to meeting deadlines without compromising quality.\nOur goal is to deliver exceptional results within the agreed timeframe, ensuring efficiency and client satisfaction. 🚀",
        },
        {
          title: "What collaboration tools do you use to manage projects?",
          info: "At Visual Folio, we use industry-leading collaboration tools to ensure seamless project management and communication:\n✅ Project Management – Trello, Asana, Jira for task tracking and workflow management.\n✅ Communication – Slack, Microsoft Teams, Zoom for real-time discussions and meetings.\n✅ File Sharing & Documentation – Google Drive, Notion, Confluence for centralized document access.\n✅ Design & Development – Figma, Adobe XD, GitHub for smooth collaboration on UI/UX and coding.\nThese tools help us maintain transparency, streamline workflows, and keep projects on track for successful completion. 🚀",
        },
        {
          title: "Do you sign NDAs or contracts before starting work?",
          info: "Yes, at Visual Folio, we prioritize confidentiality and professionalism. Before starting any project, we sign Non-Disclosure Agreements (NDAs) and formal contracts to protect your sensitive information and ensure clear project terms. These agreements outline scope, timelines, deliverables, and responsibilities, providing transparency and security for both parties. Your ideas and data remain safe with us! 🔒",
        },
      ],
    },
    {
      subTitle: "Design & Development Process",
      projectScope: [
        {
          title: "What is your approach to UI/UX design?",
          info: "At Visual Folio, our UI/UX design approach is user-centric, focusing on intuitive experiences that drive engagement and conversions. We conduct in-depth research, wireframing, prototyping, and user testing to craft seamless interfaces. Our designs blend aesthetics with functionality, ensuring visually appealing, responsive, and accessible solutions tailored to your brand identity and business goals. 🚀✨",
        },
        {
          title: "Do you offer custom design solutions for websites and apps?",
          info: "Yes! At Visual Folio, we provide custom design solutions for websites and apps, tailored to your brand identity and user needs. Our team crafts unique, responsive, and engaging designs that enhance user experience and drive conversions. Whether you need a website, mobile app, dashboard, or admin panel, we ensure a seamless and visually stunning interface built for success. 🎨",
        },
        {
          title: "How do you ensure high quality development?",
          info: "At Visual Folio, we ensure high-quality development through rigorous coding standards, continuous testing, and expert reviews at every stage. Our team follows best practices, agile methodologies, and the latest technologies to deliver secure, scalable, and efficient solutions. From UI/UX design to backend architecture, we focus on performance, security, and user experience to build robust and future-ready digital products. ✅",
        },
        {
          title: "What technologies do you work with?",
          info: "At Visual Folio, we work with a wide range of cutting-edge technologies to deliver scalable, secure, and high-performance solutions. Our expertise includes front-end frameworks like React, Angular, and Vue.js, backend technologies such as Node.js, Python, PHP, and .NET, and databases like MySQL, PostgreSQL, and MongoDB. We also specialize in mobile app development (Flutter, React Native, Swift, Kotlin), cloud solutions (AWS, Azure, Google Cloud), and AI-driven applications to meet diverse business needs. 🔧",
        },
        {
          title: "Will my website or app be mobile-friendly and responsive?",
          info: "Yes! At Visual Folio, we ensure that every website and app we develop is fully mobile-friendly and responsive. Our designs adapt seamlessly to all screen sizes, providing an optimal user experience across desktops, tablets, and smartphones. We follow best practices in responsive design, utilizing flexible grids, scalable images, and modern frameworks to guarantee a smooth, intuitive, and high-performing interface on any device. 📱💻",
        },
      ],
    },
    {
      subTitle: "Marketing & SEO",
      projectScope: [
        {
          title: "Do you provide digital marketing and SEO services?",
          info: "Yes! At Visual Folio, we offer comprehensive digital marketing and SEO services to help businesses enhance their online visibility, attract targeted traffic, and boost conversions. Our strategies include SEO optimization, content marketing, PPC campaigns, social media marketing, and analytics-driven insights to ensure maximum reach and engagement. We use the latest tools and techniques to improve search rankings, brand awareness, and overall digital presence for long-term success. 📈",
        },
        {
          title: "How do you ensure my brand gets maximum visibility?",
          info: "At Visual Folio, we ensure maximum brand visibility through a strategic mix of SEO, targeted marketing, and compelling design. Our approach includes search engine optimization, social media campaigns, paid advertising, content marketing, and data-driven insights to position your brand effectively. We tailor our strategies to your audience, ensuring higher engagement, increased traffic, and stronger brand recognition across digital platforms. 🚀📢",
        },
        {
          title:
            "What marketing strategies do you implement for business growth?",
          info: "At Visual Folio, we implement data-driven marketing strategies to drive business growth. Our approach includes SEO, content marketing, social media advertising, email campaigns, PPC, and conversion optimization to maximize reach and engagement. We analyze market trends, identify target audiences, and create customized campaigns that generate leads, boost brand awareness, and increase revenue. Our strategies ensure sustainable growth and a strong digital presence for your business. 🚀📈",
        },
        {
          title: "Can I track the progress of my SEO and marketing campaigns?",
          info: "Yes! At Visual Folio, we provide real-time tracking for your SEO and marketing campaigns using advanced analytics tools. You’ll receive detailed reports, performance insights, and regular updates to monitor rankings, traffic, conversions, and ROI. Our transparent approach ensures you stay informed about your campaign’s progress and success. 📊",
        },
        {
          title:
            "Do you offer paid advertising services (Google Ads, Social Media Ads)?",
          info: "Yes! Visual Folio offers paid advertising services across Google Ads, Facebook, Instagram, LinkedIn, Twitter X and more to help businesses reach their target audience effectively. Our team creates data-driven ad campaigns, optimizes performance, and maximizes ROI with strategic targeting, compelling ad creatives, and continuous monitoring for the best results. 🚀🎯",
        },
      ],
    },
    {
      subTitle: "Execution & Delivery",
      projectScope: [
        {
          title: "How long does it take to complete a project?",
          info: "Project timelines vary based on complexity, requirements, and scope. At Visual Folio, we provide clear time estimates before starting, ensuring efficient execution and on-time delivery. Small projects may take a few weeks, while larger ones can span months. We maintain transparent communication throughout to keep you updated. ⏳",
        },
        {
          title: "How do you ensure on-time project delivery?",
          info: "At Visual Folio, we ensure on-time project delivery through strategic planning, clear milestones, and efficient execution. Our team follows strict deadlines, agile methodologies, and continuous progress tracking to keep projects on schedule. Regular updates and proactive communication help us address challenges swiftly, ensuring smooth and timely completion. ✅",
        },
        {
          title: "Do you provide ongoing support after project completion?",
          info: "Yes! At Visual Folio, we provide ongoing support and maintenance after project completion to ensure long-term success (This is only for the 1 Month Free support after completion of the work) after that we offer on paid basis support. Our team offers updates, troubleshooting, performance optimizations, and security enhancements to keep your website, app, or digital solutions running smoothly. We’re always available to assist with any future needs!",
        },
        {
          title: "Can you assist with hosting, maintenance, and updates?",
          info: "Yes! Visual Folio offers comprehensive hosting, maintenance, and update services to keep your website or app secure, fast, and up-to-date. From server management and security patches to performance optimization and feature enhancements, we ensure your digital solutions run smoothly with minimal downtime. 💻",
        },
        {
          title:
            "What happens if I need modifications after the project is completed?",
          info: "At Visual Folio, post-project modifications are available through our paid maintenance plans, ensuring your solution stays updated and optimized. The cost depends on the complexity and workload of the required changes. Whether it's minor tweaks or major updates, we offer flexible support options tailored to your needs.",
        },
      ],
    },
    {
      subTitle: "Pricing & Payment",
      projectScope: [
        {
          title: "Do you have a refund policy?",
          info: "Yes, we offer a 100% refund policy within the first 15 days. You can evaluate the quality of work and progress during this period and decide whether to continue with further collaboration. Your satisfaction is our priority!",
        },
        {
          title: "How do you determine the cost of a project?",
          info: "At Visual Folio, project costs are determined based on scope, complexity, required technologies, and timeline. We evaluate factors like design intricacy, development hours, integrations, and resource allocation to provide a transparent and customized quote. Our pricing ensures high-quality solutions that align with your business goals and budget. 💡",
        },
        {
          title: "Do you offer flexible payment plans?",
          info: "Yes, Visual Folio offers flexible payment plans tailored to your project’s scope and budget. We provide milestone-based, weekly, monthly, or custom payment structures to ensure affordability while maintaining seamless project execution. Our goal is to make high-quality digital solutions accessible and stress-free for businesses of all sizes. 💳",
        },
        {
          title: "Are there any hidden costs in the project?",
          info: "No, at Visual Folio, we believe in complete transparency—there are no hidden costs in our projects. We provide a clear, detailed proposal upfront, outlining the scope, timeline, and pricing. Any additional work or changes are discussed and approved before implementation. Your trust is our priority! ✅",
        },
        {
          title: "What payment methods do you accept?",
          info: "At Visual Folio, we currently accept Payoneer as our primary payment method. This ensures secure, fast, and hassle-free transactions for our clients worldwide. We prioritize transparency and reliability in all financial dealings. 💼💳",
        },
        {
          title: "Do you provide invoices and contracts for all services?",
          info: "Yes, at Visual Folio, we provide detailed invoices and contracts for all our services to ensure transparency and clarity. Our agreements outline project scope, costs, and timelines, giving you full confidence in our process. 📄",
        },
        {
          title: "How much do you charge upfront to start a project?",
          info: "We require a 50% upfront payment for fixed-budget projects after signing the contract and then every week. This ensures a smooth project kickoff, resource allocation, and timely delivery while maintaining transparency and quality.",
        },
      ],
    },
  ]
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])

  const [openFaqIndex, setOpenFaqIndex] = useState<string | null>(null)

  const toggleFaqIndex = (uniqueIndex: string) => {
    setOpenFaqIndex((prevIndex) =>
      prevIndex === uniqueIndex ? null : uniqueIndex
    )
  }
  const [rootElement, setRootElement] = React.useState<HTMLElement | null>(null)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const element = document.getElementById("___gatsby")
      setRootElement(element)
    }
  }, [])
  return (
    <div>
      <div className="faq lg:rounded-tr-[30%] rounded-tr-[10%] lg:rounded-tl-[30%] rounded-tl-[10%]">
        <p className="text-glass-white pt-20 text-center text-xl font-semibold">
          Our Service Steps & Work Process
        </p>
        <div className="container mx-auto flex lg:flex-row flex-col justify-around items-center my-10">
          <div className="lg:w-[40%] w-full px-2">
            <div>
              <p className="text-glass-white text-2xl font-semibold">
                Relax because we always <br /> will be here for you 24/7
              </p>
              <p className="text-glass-white lg:text-sm text-xs py-4">
                We’ll always be here for you providing support, expertise, and
                reliable solutions whenever you need them. Your success is our
                commitment!
              </p>
            </div>
            <div>
              <div className="text-glass-white flex gap-2">
                <p className="font-bold">✓</p>
                <div>
                  <p className="font-bold text-sm">
                    Our work flow are simple and unique
                  </p>
                  <p className="lg:text-sm text-xs py-2">
                    Our streamlined process ensures efficiency, clarity, and
                    innovation, making every step smooth and hassle-free for
                    you. Simplicity meets excellence!
                  </p>
                </div>
              </div>
              <div className="text-glass-white flex gap-2 pt-3">
                <p className="font-bold">✓</p>
                <div>
                  <p className="font-bold text-sm">
                    Best fit for your business
                  </p>
                  <p className="lg:text-sm text-xs py-2">
                    Our library makes things simple like never before, by Our
                    tailored solutions are designed to align with your goals,
                    ensuring efficiency, growth, and long-term success. Let’s
                    build something great together with very small steps!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-[50%] px-2">
            <p className="text-glass-white px-3 py-4">
              Getting Started The Process
            </p>
            <div
              className={` shadow-2xl rounded-b-xl w-full lg:mx-3 px-10 py-4 ${theme == "glassy" ? "bg-[#E6E9EF]" : theme === "light" ? "bg-[#E6E9EF] bg-primary-shadow" : theme === "dark" ? "bg-completedProject bg-primary-shadow-dark" : "bg-testimonial"}`}
            >
              {faqList?.map((faq, index) => (
                <div className="border-b pb-5">
                  <div
                    onClick={() => setIdx(index === idx ? null : index)}
                    className="flex justify-between cursor-pointer items-center"
                  >
                    <p className="text-black font-semibold pt-3">
                      {faq?.title}
                    </p>
                    <div>
                      {index === idx ? (
                        <div className="px-1 h-[2px] bg-[#7B68EC]"></div>
                      ) : (
                        <div className="text-[#7B68EC]">+</div>
                      )}
                    </div>
                  </div>
                  <div>
                    {index === idx && (
                      <p
                        className="text-xs text-[#5A7184] tracking-wide pt-2"
                        dangerouslySetInnerHTML={{
                          __html: faq?.info.replace(/\n/g, "<br />"),
                        }}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="faq">
        <div className="container mx-auto flex-wrap flex lg:flex-row flex-col justify-between items-center my-10">
          {otherFaqList?.map((otherFaqs, index) => (
            <div key={index} className="lg:w-[45%] mt-5 px-2">
              <p className="text-glass-white px-3 py-4">
                {otherFaqs?.subTitle}
              </p>
              <div
                className={` shadow-2xl rounded-b-xl w-full lg:mx-3 px-10 py-4 ${theme == "glassy" ? "bg-[#E6E9EF]" : theme === "light" ? "bg-[#E6E9EF] bg-primary-shadow" : theme === "dark" ? "bg-completedProject bg-primary-shadow-dark" : "bg-testimonial"}`}
              >
                {otherFaqs?.projectScope?.map((faq, faqIndex) => {
                  const uniqueIndex = `${index}-${faqIndex}`
                  return (
                    <div key={faqIndex} className="border-b pb-5">
                      <div
                        onClick={() => toggleFaqIndex(uniqueIndex)}
                        className="flex justify-between cursor-pointer items-center"
                      >
                        <p className="text-black font-semibold pt-3">
                          {faq?.title}
                        </p>
                        <div>
                          {openFaqIndex === uniqueIndex ? (
                            <div className="px-1 h-[2px] bg-[#7B68EC]"></div>
                          ) : (
                            <div className="text-[#7B68EC]">+</div>
                          )}
                        </div>
                      </div>
                      <div>
                        {openFaqIndex === uniqueIndex && (
                          <p
                            className="text-xs text-[#5A7184] tracking-wide pt-2 "
                            dangerouslySetInnerHTML={{
                              __html: faq?.info.replace(/\n/g, "<br />"),
                            }}
                          ></p>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="result-bg py-10">
        <p className="lg:text-4xl md:text-3xl sm:text-xl text-lg text-center text-glass-white">
          <span className="font-bold">Get results</span> you’ll want <br /> to
          take credit for
        </p>
        <div className="flex justify-center mt-4 pt-5">
          {rootElement && (
            <PopupButton
              className="px-6 py-3 bg-btn-result book-free-consultancy-radius text-purple text-black font-inter lg:text-sm text-xs whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in rounded-lg bg-btn bg-glass"
              url="https://calendly.com/visualfolio-info/30min"
              rootElement={rootElement}
              text="Book Your Free Consultation"
            />
          )}
        </div>
      </div>
    </div>
  )
}
